import Vue from "vue"
import * as types from './types'

export default {
  category_uuid: state => state.category_uuid,
  categoryList: state => state.categoryList,
  sub_category_uuid: state => state.sub_category_uuid,
  coupon_message: state => state.coupon_message,
  menuDeal: state => state.menu_deal,
  selectedCategory: state => state.selectedCategory,
  selectedSubCategory: state => state.selectedSubCategory,
  selectedProduct: state => state.selectedProduct,
  selectedCart: state => state.selectedCart,
  selectedOrderTime: state => state.selectedOrderTime,
  selectedOutlet: state => state.selectedOutlet,
  selectedHutOutletId: state => state.selectedHutOutletId,
  selectedHutOutlet: state => state.selectedHutOutlet,
  isValidOrderTime: state => state.isValidOrderTime,
  selectedDisposition: state => state.selectedDisposition,
  paymentStatus: state => state.paymentStatus,
  sidebarOpen: state => state.sidebarOpen,
  homeSidebarOpen: state => state.homeSidebarOpen,
  user: state => {
    if (state.user) {
      return state.user
    } else {
      return Vue.auth.user()
    }
  },
  lang: state => state.lang,
  shouldTriggerChoosingTopping: state => state.shouldTriggerChoosingTopping,
  [types.GET_SELECTED_SIZE]: state => state.selectedSizeCrust.size,
  [types.GET_SELECTED_CRUST]: state => state.selectedSizeCrust.crust,
  [types.GET_BOTH_SELECTED_SIZE_N_CRUST]: state => state.selectedSizeCrust,
  [types.GET_EXTRA_TOPPINGS]: state => state.extraToppings,
  [types.GET_ADDED_EXTRA_TOPPINGS]: state => state.addedExtraToppings,
  [types.GET_DEFAULT_TOPPINGS]: state => state.defaultToppings,
  [types.GET_REMOVED_DEFAULT_TOPPINGS]: state => state.removedDefaultToppings,
  [types.GET_LAND_ON_HOMEPAGE]: state => state.isLandOnHomepage,
  
  /**
   * HH
   * */
  [types.GET_SELECTED_HH_SIZE]: state => state.hhSelectedSizeCrust.size,
  [types.GET_SELECTED_HH_CRUST]: state => state.hhSelectedSizeCrust.crust,
  [types.GET_BOTH_SELECTED_HH_SIZE_N_CRUST]: state => state.hhSelectedSizeCrust,
  [types.GET_HH_SIZES]: state => state.hhSizes,
  [types.GET_HH_CRUSTES]: state => state.hhCrustes,
  [types.GET_HH_PIZZA_LIST]: state => state.hhPizzaList,

  // LEFT pizza
  [types.GET_LEFT_PIZZA]: state => state.hhLeftPizza,
    // *** LEFT toppings
  [types.GET_LEFT_EXTRA_TOPPINGS]: state => state.pzzLeftExtraToppings,
  [types.GET_LEFT_DEFAULT_TOPPINGS]: state => state.pzzLeftDefaultToppings,
  [types.GET_LEFT_ADDED_EXTRA_TOPPINGS]: state => state.pzzLeftAddedExtraToppings,
  [types.GET_LEFT_REMOVED_DEFAULT_TOPPINGS]: state => state.pzzLeftRemovedDefaultToppings,

  // RIGHT pizza
  [types.GET_RIGHT_PIZZA]: state => state.hhRightPizza,
    // *** RIGHT toppings
  [types.GET_RIGHT_EXTRA_TOPPINGS]: state => state.pzzRightExtraToppings,
  [types.GET_RIGHT_DEFAULT_TOPPINGS]: state => state.pzzRightDefaultToppings,
  [types.GET_RIGHT_ADDED_EXTRA_TOPPINGS]: state => state.pzzRightAddedExtraToppings,
  [types.GET_RIGHT_REMOVED_DEFAULT_TOPPINGS]: state => state.pzzRightRemovedDefaultToppings,
  [types.GET_HUT_REWARD]: state => state.hutReward,
  [types.GET_MAINTAINANCE_HUT_REWARD]: state => state.maintainanceHutReward,
  [types.GET_SLICES_REWARD]: state => state.slicesReward
}



// WEBPACK FOOTER //
// ./src/store/getters.js